module.exports = __webpack_public_path__ + "img/bg-sm.b509362c.png";